var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    staticClass: "sticker patternmaker-patternmaker-view-thumbnails",
    attrs: {
      "elementType": "section"
    }
  }, [_vm.enableSwiper ? _c('CustomContainer', {
    attrs: {
      "customClass": "patternmaker-patternmaker-view-thumbnails-wrapper",
      "elementType": "div"
    }
  }, [_c('swiper', {
    ref: "swiper",
    class: ['patternmaker-patternmaker-view-thumbnails-wrapper-swiper', {
      'patternmaker-patternmaker-view-thumbnails-wrapper-swiper--no-loop': !_vm.swiperOptions.loop
    }],
    attrs: {
      "auto-update": false,
      "auto-destroy": false,
      "delete-instance-on-destroy": false,
      "cleanup-styles-on-destroy": false,
      "options": _vm.swiperOptions
    },
    on: {
      "touchEnd": _vm.stickerTouched,
      "slideChange": _vm.stickerSlideChanged
    }
  }, _vm._l(_vm.stickers, function (item, index) {
    return _c('swiper-slide', {
      key: index,
      class: ['patternmaker-patternmaker-view-item', {
        active: item.id === _vm.currentSticker,
        disabled: !_vm.enabled
      }],
      attrs: {
        "data-sticker-id": item.id
      }
    }, [_c('CustomContainer', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.id === _vm.currentSticker,
        expression: "item.id === currentSticker"
      }],
      attrs: {
        "elementType": "div",
        "customClass": "icon-check"
      }
    }), _c('CustomImage', {
      attrs: {
        "customClass": "background",
        "src": item.thumb,
        "alt": item.display_name.default,
        "data-sticker-id": item.id,
        "data-sticker-group-name": item.originalGroup
      }
    }), item.color ? _c('CustomContainer', {
      style: "background-color: ".concat(item.color),
      attrs: {
        "elementType": "div",
        "customClass": "background",
        "data-swatch-id": item.id
      }
    }) : _vm._e()], 1);
  }), 1), _c('CustomContainer', {
    attrs: {
      "customClass": ['patternmaker-patternmaker-view-thumbnails-wrapper-nav-wrapper', {
        'hide': !_vm.enableCarouselNavigation
      }],
      "elementType": "div"
    }
  }, [_c('button', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-previous stickers",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left-indicator-open patternMaker-arrow",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  })]), _c('button', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-next stickers",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right-indicator-open patternMaker-arrow",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })])])], 1) : _c('base-spinner', {
    attrs: {
      "size": "50",
      "position": "inherit"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }